import {ProTaskForm} from './pro-task.form';
import {UnveroSelectedStationEntry} from './unvero/unvero-selected-station.entry';

export class ProTasksFormData {

  public forms: Array<ProTaskForm>;
  public confirmTasks: boolean;
  public fuelWarning: boolean;
  public enabledDefaultWaypoints: boolean;
  public copyEnabled: boolean;
  public driverLang: string;
  public lkwOrderId: number;
  public unveroSelectedStation: UnveroSelectedStationEntry;

  constructor(forms: Array<ProTaskForm>,
              confirmTasks: boolean,
              fuelWarning: boolean,
              enabledDefaultWaypoints: boolean,
              copyEnabled: boolean,
              driverLang: string,
              lkwOrderId: number,
              unveroSelectedStation: UnveroSelectedStationEntry) {

    this.forms = forms;
    this.confirmTasks = confirmTasks;
    this.fuelWarning = fuelWarning;
    this.enabledDefaultWaypoints = enabledDefaultWaypoints;
    this.copyEnabled = copyEnabled;
    this.driverLang = driverLang;
    this.lkwOrderId = lkwOrderId;
    this.unveroSelectedStation = unveroSelectedStation;
  }

}
